export default {
  computed: {
    localTelNo(){
      return (this.$store.state.contactInfo.telephones) ? JSON.parse(this.$store.state.contactInfo.telephones).local_number : "";
    }, 
    internationalTelNo(){
      return (this.$store.state.contactInfo.telephones) ? JSON.parse(this.$store.state.contactInfo.telephones).international_number : "";
    },
    faxNo(){
      return (this.$store.state.contactInfo.telephones) ? JSON.parse(this.$store.state.contactInfo.telephones).fax_number : "";
    }
  },
}